function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1050.125 -1824.252)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1050.125 1824.252)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M484.447,535.578h-9.64a2.084,2.084,0,0,0-2.364,2.364v10.281c0,1.19-.021,2.38.025,3.571a1.957,1.957,0,0,0,1.97,1.894h1.815c.809,0,.968-.159.972-.956v-5.448c0-.528.088-1.069-.457-1.442-.1-.067-.088-.339-.092-.515V541.2c0-.968,0-.968.947-1.3a14.466,14.466,0,0,1,4.581-.734c1.974-.034,3.957,0,5.922.126a23.87,23.87,0,0,1,3.47.725.721.721,0,0,1,.591.838c-.034,1.354,0,2.712,0,4.065,0,.449.1.922-.365,1.258-.076.055-.092.235-.092.36v6.538a.541.541,0,0,0,.612.608h1.651a3.776,3.776,0,0,0,.922-.071,2.046,2.046,0,0,0,1.513-2.263V537.938a1.559,1.559,0,0,0-.038-.545,4.69,4.69,0,0,0-.549-1.161,2.092,2.092,0,0,0-1.836-.662C490.822,535.583,487.632,535.578,484.447,535.578Z",
  transform: "translate(-472.439 -535.57)",
  fill: "#1fc5db"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.981,12.981A4.491,4.491,0,1,0,8.491,8.491,4.489,4.489,0,0,0,12.981,12.981Zm0,2.245c-3,0-8.981,1.5-8.981,4.491V20.84H21.963V19.718C21.963,16.731,15.979,15.227,12.981,15.227Z",
  transform: "translate(1049.494 1826.656)",
  fill: "#1fc5db"
}));

var SvgPowerfull = function SvgPowerfull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23.244,
    viewBox: "0 0 24 23.244",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPowerfull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/powerfull.81913259.svg";
export { ForwardRef as ReactComponent };